export const QUERY_KEY = {
  GET_PENDING_CERTIFICATE: "get-pending-certificate",
  GET_DAILY_VISITOR: "get-daily-visitor",
  GET_QUEUE: "get-queue",
  GET_SEARCH_QUEUE: "get-search-queue",
  GET_SHIFTS: "get-shifts",
  GET_QUEUE_STATUS: "get-queue-status",
  GET_VACCINE_TYPE: "get-vaccine-type",
  GET_TODAYS_QUEUE_INFO: "get-todays-queue-info",
  GET_TODAYS_ONLINE_QUEUE_INFO: "get-todays-online-queue-info",
  GET_ALL_ACTIVE_QUEUE: "get-all-active-queue",
  GET_QUEUE_ALL_CONFIGURATION: "get-queue-all-configuration",
  GET_QUEUE_CONFIGURATION_BY_ID: "get-queue-configuration-by-id",
  GET_DISPLAY_QUEUE: "get-display-queue",
};
